/* The height above the hero is measured at runtime: the announcement bar wraps on mobile and reflows once fonts land. */
(() => {
  const heroes = document.querySelectorAll('[data-bronte-hero]');
  if (!heroes.length) return;

  let frame = null;

  const measure = () => {
    frame = null;
    heroes.forEach((hero) => {
      const top = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty('--bronte-hero-offset', `${Math.max(0, Math.round(top))}px`);
    });
  };

  const schedule = () => {
    if (frame !== null) return;
    frame = requestAnimationFrame(measure);
  };

  measure();

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  const group = document.getElementById('header-group');
  if (group && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    [...group.children].forEach((child) => {
      if (!child.querySelector('[data-bronte-header]')) observer.observe(child);
    });
  }
})();
